var React = require('react');

function IconHamburger (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#1B1D23","fillRule":"evenodd"},React.createElement("path",{"d":"M0 0h24v3H0zM0 7h24v3H0zM0 14h24v3H0z"})));
}

IconHamburger.defaultProps = {"width":"24","height":"17"};

module.exports = IconHamburger;

IconHamburger.default = IconHamburger;
